import { render, staticRenderFns } from "./DealsFormDeclined.vue?vue&type=template&id=610887c2&"
import script from "./DealsFormDeclined.vue?vue&type=script&lang=js&"
export * from "./DealsFormDeclined.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports